import { Chip, Tooltip, Box, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";

/**
 * Componente para mostrar badge cuando el sistema auto-detecta clasificación LLC
 * @param {string} vehiculo - Tipo de vehículo de inversión
 * @param {boolean} showTooltip - Si mostrar tooltip con explicación (default: true)
 * @param {boolean} showIcon - Si mostrar ícono en el chip (default: true)
 * @param {string} size - Tamaño del chip: "small" | "medium" (default: "small")
 */
const LLCClassificationBadge = ({
  vehiculo,
  showTooltip = true,
  showIcon = true,
  size = "small",
}) => {
  // Verificar si el vehículo es LLC (case insensitive)
  const isLLC = vehiculo?.toUpperCase() === "LLC";

  // Si no es LLC, no mostrar nada
  if (!isLLC) {
    return null;
  }

  // Chip básico
  const chipComponent = (
    <Chip
      label="LLC Auto-detectada"
      color="success"
      size={size}
      variant="outlined"
      icon={showIcon ? <BusinessIcon /> : undefined}
    />
  );

  // Si no se debe mostrar tooltip, retornar solo el chip
  if (!showTooltip) {
    return chipComponent;
  }

  // Tooltip con explicación de la auto-detección
  const tooltipContent = (
    <Box sx={{ p: 0.5, maxWidth: 300 }}>
      <Typography variant="body2" fontWeight="bold" gutterBottom sx={{ color: '#fff' }}>
        Clasificación LLC Auto-detectada
      </Typography>
      <Typography variant="body2" sx={{ color: '#fff' }}>
        El sistema detectó automáticamente que este proyecto utiliza una
        estructura LLC (Limited Liability Company).
      </Typography>
      <Typography variant="body2" sx={{ color: '#fff', mt: 1 }}>
        Esta clasificación puede afectar:
      </Typography>
      <Typography variant="body2" component="ul" sx={{ color: '#fff', pl: 2, my: 0.5 }}>
        <li>Tratamiento fiscal de distribuciones</li>
        <li>Reportes y documentación</li>
        <li>Cálculo de retenciones</li>
      </Typography>
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      {chipComponent}
    </Tooltip>
  );
};

export default LLCClassificationBadge;
